<script setup lang="ts"></script>

<template>
    <div class="min-h-screen flex items-start justify-center pt-[20vh] bg-gray-50 relative overflow-hidden">
        <slot />
    </div>
</template>
